export default {
    orderNewPatch: {
        Status: 'Status',
        oStatus: 'Order Status',
        wmsStatus: 'Operation Status',
        Editing: 'Editing',
        editSuccessful:'Edit Successful',
        editFailed:'Edit Failed',
        Cancelling: 'Canceling',
        cancelSuccessful:'Cancel Successful',
        cancelFailed:'Cancel Failed',
        order: 'Order No.',
        Import: 'Import',
        CustomerOrder: 'Customer Order No.',
        Reason: 'Error Type',
        Detail: 'Error Details',
        Ordered: 'Ordered Date',
        Created: 'ERP Received',
        WMSSyncTime: 'WMS Sync Time',
        Uploaded: 'Date Uploaded',
        pickup: 'Pick Up Time',
        Information: 'Order Information',
        Receiver: 'Receiver Information',
        ReceiverNotes: 'Receiver Notes',
        Product: 'Product Name',
        Shipping: 'Shipping Method',
        ShippingCost: 'Shipping Cost',
        Courier: 'Courier',
        Reprocess: 'Reprocess Order',
        lock: 'WMS Lock Time',
        delivery: 'WMS Delivery Time',
        filePs1: '1.Please update the shipping label here.Max size 5MB',
        filePs2: '2.Please use the tracking number as the file name',
        orderDate: 'Ordered Date',
        creationDate: 'ERP Received Date',
        sapPushTime: 'WMS Received Date',
        hjShipmentTime: 'HJ Closure Date',
        receiveTime: 'ERP Closure Date',
    }
};
